import { rootApi } from "../../api/rootApi";

export const batchApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchAllBikajiOrders: builder.mutation({
            query: (params) => ({
                method: "POST",
                url: `/tenant/orders/all-order`,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + params.token,
                    slug: params.tenant_id,
                },
                body: params.body,
            }),
        }),

        updateOrderStatusBikaji: builder.mutation({
            query: (params) => ({
                method: "POST",
                url: `/tenant/orders/update-order`,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + params.token,
                    slug: params.tenant_id,
                },
                body: params.body,
            }),
        }),

        fetchAllBikajiShelf: builder.mutation({
            query: (params) => ({
                method: "POST",
                url: `/tenant/orders/all-shelf`,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + params.token,
                    slug: params.tenant_id,
                },
                body: params.body,
            }),
        }),

        updateShelfStatusBikaji: builder.mutation({
            query: (params) => ({
                method: "POST",
                url: `/tenant/orders/update-shelf`,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + params.token,
                    slug: params.tenant_id,
                },
                body: params.body,
            }),
        }),

        fetchBikajiLedger: builder.mutation({
            query: (params) => ({
                method: "GET",
                url: `/tenant/bikaji/order/users?month=${params.month}&year=${params.year}`,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + params.token,
                    slug: params.tenant_id,
                },
            }),
        }),

        extractInvoiceFields: builder.mutation({
            query: (params) => ({
                method: "POST",
                url: `/tenant/bikaji/extract`,
                headers: {
                    Authorization: "Bearer " + params.token,
                    slug: params.tenant_id,
                    "Content-Type": "application/json",
                },
                body: params.body,
            }),
        }),

        fetchUserOrder: builder.mutation({
            query: (params) => ({
                method: "GET",
                url: `/tenant/bikaji/order/list?user_id=${params.user_id}&start_date=${params.start_date}&end_date=${params.end_date}`,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + params.token,
                    slug: params.tenant_id,
                },
            }),
        }),

        updateUserOrder: builder.mutation({
            query: (params) => ({
                method: "POST",
                url: `/tenant/bikaji/order/transferPoint`,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + params.token,
                    slug: params.tenant_id,
                },
                body: params.body,
            }),
        }),

        saveExtractData: builder.mutation({
            query: (params) => ({
                method: "POST",
                url: `/tenant/bikaji/extract/save`,
                headers: {
                    Authorization: "Bearer " + params.token,
                    slug: params.tenant_id,
                    "Content-Type": "application/json",
                },
                body: params.body,
            }),
        }),

        detectShelfProducts: builder.mutation({
            query: (params) => ({
                method: "POST",
                url: `/tenant/bikaji/detect-shelf`,
                headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + params.token,
                slug: params.tenant_id,
                },
                body: params.body,
            }),
         }),
    }),
});

export const {
    useFetchAllBikajiOrdersMutation,
    useUpdateOrderStatusBikajiMutation,
    useFetchAllBikajiShelfMutation,
    useUpdateShelfStatusBikajiMutation,
    useFetchBikajiLedgerMutation,
    useFetchUserOrderMutation,
    useUpdateUserOrderMutation,
    useExtractInvoiceFieldsMutation,
    useSaveExtractDataMutation,
    useDetectShelfProductsMutation,
} = batchApi;